import { Injectable, } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { BaseApiService } from './base-api.service';
import { UserGroupModel } from './../models';

@Injectable()
export class UserGroupService extends BaseApiService {

    getGroups(): Observable<UserGroupModel[]> {
        return this.get<UserGroupModel[]>(`/api/usersgroups`);
    }

    getGroup(id: Number): Observable<UserGroupModel> {
        return this.get<UserGroupModel>(`/api/usersgroups/${id}`);
    }

    saveGroup(item: UserGroupModel): Observable<number> {
        return this.post<number>(`/api/usersgroups`, item);
    }

    deleteGroup(id: number): Observable<boolean> {
        return this.delete(`/api/usersgroups/${id}`);
    }
}



// WEBPACK FOOTER //
// ./src/app/services/user-group.service.ts